import React from "react";
import styles from "./RichMessageView.css";
import { Button, RichCard } from "../RichMessageTypes";
import { ButtonContent, ButtonsStyleType } from "../components/buttons/ButtonContent";
import { Carousel } from "../components/carousel/Carousel";

interface Props {
  richCards: RichCard[];
  buttons: Button[];
  disableTextButtons?: boolean;
  isMobile?: boolean;
}

export const RichMessageView = ({ richCards, buttons, disableTextButtons, isMobile }: Props) => {
  return (
    <div className={styles["form-wrapper"]}>
      {richCards && richCards.length > 0 && (
        <Carousel cards={richCards} disableTextButtons={disableTextButtons} isMobile={isMobile} />
      )}

      {buttons && buttons.length > 0 && (
        <ButtonContent
          buttons={buttons}
          buttonsStyle={ButtonsStyleType.CHAT_BUTTONS}
          disableTextButtons={disableTextButtons}
        />
      )}
    </div>
  );
};
